import React from 'react';
export function AvisoLegalContent() {
  return <div className="space-y-5" data-id="element-191">
      <p data-id="element-192">
        El presente documento regula el acceso, navegación y uso del sitio web,
        entrenamientos, formularios, contenidos digitales y servicios ofrecidos
        por Bitzen y su sistema BitzenEscala™.
      </p>
      <p data-id="element-193">
        Al acceder a este sitio o participar en cualquiera de nuestros
        entrenamientos, aceptas expresamente los presentes Términos de Uso.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-194">
        1. Identificación del responsable
      </h3>
      <ul className="space-y-1 list-none" data-id="element-195">
        <li data-id="element-196">
          <span className="font-semibold text-slate-800" data-id="element-197">Marca / Empresa:</span>{' '}
          Bitzen
        </li>
        <li data-id="element-198">
          <span className="font-semibold text-slate-800" data-id="element-199">Actividad:</span>{' '}
          Desarrollo de sistemas ecommerce, automatización y consultoría digital
          para pymes de retail.
        </li>
        <li data-id="element-200">
          <span className="font-semibold text-slate-800" data-id="element-201">Responsable:</span>{' '}
          Nicolás Riquelme, Fundador y CEO.
        </li>
      </ul>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-202">
        2. Objeto del sitio y de los contenidos
      </h3>
      <p data-id="element-203">
        El objetivo de este sitio, entrenamientos, webinars, FFW, materiales
        descargables y comunicaciones es brindar información educativa,
        estratégica y comercial sobre ecommerce, automatización y escalamiento
        de ventas online.
      </p>
      <p data-id="element-204">
        Los contenidos no constituyen asesoría legal, financiera ni contable
        personalizada.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-205">
        3. Uso adecuado del sitio
      </h3>
      <p data-id="element-206">El usuario se compromete a:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-207">
        <li data-id="element-208">
          Utilizar el sitio y los contenidos de forma lícita y responsable.
        </li>
        <li data-id="element-209">
          No emplear los contenidos con fines fraudulentos, ilegales o no
          autorizados.
        </li>
        <li data-id="element-210">
          No copiar, reproducir, distribuir o revender los contenidos sin
          autorización expresa de Bitzen.
        </li>
      </ul>
      <p data-id="element-211">
        El uso indebido podrá dar lugar a la suspensión del acceso y a las
        acciones legales correspondientes.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-212">
        4. Propiedad intelectual
      </h3>
      <p data-id="element-213">
        Todos los contenidos, textos, estructuras, metodologías, nombres
        comerciales, marcas, sistemas y materiales (incluyendo BitzenEscala™)
        son propiedad exclusiva de Bitzen o de sus respectivos titulares.
      </p>
      <p data-id="element-214">
        Queda prohibida su reproducción total o parcial sin autorización previa
        y por escrito.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-215">
        5. Limitación de responsabilidad
      </h3>
      <p data-id="element-216">
        Bitzen no garantiza resultados económicos específicos. Los resultados
        mencionados en entrenamientos o materiales (plazos, conversiones,
        porcentajes, ventas) dependen de múltiples factores, entre ellos:
      </p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-217">
        <li data-id="element-218">Tráfico disponible</li>
        <li data-id="element-219">Oferta del cliente</li>
        <li data-id="element-220">Mercado</li>
        <li data-id="element-221">Capacidad operativa del negocio</li>
        <li data-id="element-222">Correcta implementación del sistema</li>
      </ul>
      <p data-id="element-223">
        Cada negocio es responsable de la aplicación de las estrategias y
        decisiones que tome.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-224">
        6. Enlaces a terceros
      </h3>
      <p data-id="element-225">
        Este sitio puede contener enlaces a plataformas externas (CRM, email
        marketing, sistemas de pago, redes sociales). Bitzen no se
        responsabiliza por el contenido, funcionamiento o políticas de dichos
        terceros.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-226">
        7. Modificaciones
      </h3>
      <p data-id="element-227">
        Bitzen se reserva el derecho de modificar, actualizar o eliminar estos
        Términos de Uso y Avisos Legales en cualquier momento, sin previo aviso.
        Las modificaciones entrarán en vigor desde su publicación.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-228">
        8. Legislación aplicable
      </h3>
      <p data-id="element-229">
        Estos Términos de Uso se rigen por las leyes vigentes de la República de
        Chile, sin perjuicio de su aplicación en otros países de Latinoamérica.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-230">
        9. Aceptación
      </h3>
      <p data-id="element-231">
        El acceso a este sitio, la participación en entrenamientos o el envío de
        información a través de formularios implica la aceptación total y sin
        reservas de estos Avisos Legales y Términos de Uso.
      </p>
    </div>;
}
export function PoliticasContent() {
  return <div className="space-y-5" data-id="element-232">
      <p data-id="element-233">
        En Bitzen valoramos y respetamos tu privacidad. Esta Política de
        Privacidad describe cómo recopilamos, utilizamos y protegemos la
        información personal que nos proporcionas a través de nuestros
        formularios, entrenamientos, páginas web y sistemas digitales.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-234">
        1. Información que recopilamos
      </h3>
      <p data-id="element-235">Podemos recopilar información personal como:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-236">
        <li data-id="element-237">Nombre y apellido</li>
        <li data-id="element-238">Correo electrónico</li>
        <li data-id="element-239">Número de teléfono</li>
      </ul>
      <p data-id="element-240">
        Esta información se obtiene únicamente cuando el usuario la proporciona
        de manera voluntaria a través de formularios, registros o agendamientos.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-241">
        2. Uso de la información
      </h3>
      <p data-id="element-242">La información recopilada se utiliza para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-243">
        <li data-id="element-244">Contactarte y brindarte información sobre nuestros servicios.</li>
        <li data-id="element-245">
          Enviarte contenidos educativos, entrenamientos o comunicaciones
          relacionadas con BitzenEscala™.
        </li>
        <li data-id="element-246">Evaluar si tu negocio califica para nuestros servicios.</li>
        <li data-id="element-247">
          Mejorar nuestros procesos, contenidos y experiencia del usuario.
        </li>
        <li data-id="element-248">
          Realizar acciones de seguimiento mediante email, WhatsApp u otros
          canales de comunicación.
        </li>
      </ul>
      <p data-id="element-249">
        Nunca utilizaremos tu información para fines distintos a los aquí
        descritos.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-250">
        3. Protección de la información
      </h3>
      <p data-id="element-251">
        Implementamos medidas técnicas y organizativas para proteger tu
        información personal y evitar accesos no autorizados, uso indebido o
        divulgación.
      </p>
      <p data-id="element-252">
        No vendemos, alquilamos ni compartimos tus datos personales con terceros
        no autorizados.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-253">
        4. Herramientas y terceros
      </h3>
      <p data-id="element-254">
        Podemos utilizar herramientas externas como plataformas de email
        marketing, CRM, sistemas de analítica y plataformas publicitarias (como
        Meta o Google) únicamente para fines de comunicación, seguimiento y
        optimización de nuestros servicios.
      </p>
      <p data-id="element-255">Estas plataformas cumplen con estándares de seguridad y privacidad.</p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-256">
        5. Comunicaciones
      </h3>
      <p data-id="element-257">
        Al proporcionar tus datos, aceptas recibir comunicaciones relacionadas
        con nuestros contenidos, entrenamientos, servicios u ofertas. Puedes
        solicitar la baja de nuestras comunicaciones en cualquier momento.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-258">
        6. Derechos del usuario
      </h3>
      <p data-id="element-259">Tienes derecho a:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-260">
        <li data-id="element-261">Acceder a tu información personal.</li>
        <li data-id="element-262">Solicitar la modificación o eliminación de tus datos.</li>
        <li data-id="element-263">Retirar tu consentimiento para el uso de tu información.</li>
      </ul>
      <p data-id="element-264">
        Para ejercer estos derechos, puedes escribirnos directamente a nuestro
        correo de contacto.
      </p>

      <h3 className="font-heading font-bold text-navy-900 text-base md:text-lg pt-3" data-id="element-265">
        7. Cambios en la política
      </h3>
      <p data-id="element-266">
        Bitzen se reserva el derecho de actualizar o modificar esta Política de
        Privacidad en cualquier momento. Cualquier cambio será publicado en esta
        misma sección.
      </p>
    </div>;
}